export default __webpack_public_path__ + "static/media/chevron-slider-right.2eade7ed.svg";